<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QFl7ge/tc-custom/9781497612341.jpg?1733123507574" alt="This image is the cover for the book Atlantic Abomination"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Atlantic Abomination
      </h1>
      <p class="bookDescription body article font2">
        <b>An alien hidden in the ocean’s depths is awakened—and wreaks havoc on mankind—in this science fiction classic from the Hugo Award–winning author.</b><br/><br/> In <i>The Atlantic Abomination</i>, an exploratory expedition to the bottom of the ocean discovers the remnants of a long-lost civilization, and then, the enormous body of an alien being preserved for unknown millennia. An attempt to raise the body unleashes a horror beyond imagining as the creature revives from a long sleep and begins to exert control over men’s minds throughout the world. This is a classic SF horror story in the mode of John W. Campbell’s <i>The Thing</i>, the source material for SF thriller movies in the 1950s and again, via John Carpenter, in the 1980s.<br/><br/> For each generation, there is a writer meant to bend the rules of what we know. Hugo Award winner (Best Novel, <i>Stand on Zanzibar</i>) and British science fiction master John Brunner remains one of the most influential and respected authors of all time, and now many of his classic works are being reintroduced. For readers familiar with his vision, this is a chance to reexamine his thoughtful worlds and words, while for new readers, Brunner’s work proves itself the very definition of timeless.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Brunner
      </h2>
      
      <p class="authorDescription body article">John Brunner started his career as a productive writer of Ace Double Science Fiction novels, sometimes writing both sides of the same double. He produced a wide variety of entertaining and well-conceived science fiction adventures before testing his ambitions with more and more complex and stylistically sophisticated novels. Among his triumphs are&#160;<I>Stand on Zanzibar</I>&#160;(Hugo winner for Best Novel),&#160;<I>The Jagged Orbit</I>,&#160;<I>The Sheep Look Up</I>,&#160;<I>The Shockwave Rider</I>, and&#160;<I>A Maze of Stars</I>. Although he wrote relatively little fantasy, he was widely acclaimed for a series of short stories collected as&#160;<I>The Compleat Traveller in Black</I>. Brunner also wrote mysteries, thrillers, and several well-regarded historical novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47333cee